export const contactEmail = 'hello@grafbase.com'
export const supportEmail = 'support@grafbase.com'
